module.exports = __webpack_public_path__ + "static/media/voice-mail.38bec43b.svg";